import React, { useEffect } from 'react';
import styles from './styles.module.css';
import Badge from '@/components/general/Badge';
import SectionHead from '@/components/general/SectionHead';
import AvatarBadges from './AvatarBadges';
import { PlateLookup } from './PlateLookup';

import { HeroVisual } from './HeroVisual';
import { useLayoutContext } from '@/context/LayoutContext';
import { Car } from '@/commonTypes';
import LookupResult from './LookupResult';
import StatsComponent from './StatsComponent';
import { useTranslations } from 'next-intl';

export default function HomeHero() {
  const t = useTranslations('HomePage.hero');
  const tStats = useTranslations('HomePage.stats');
  const hero = {
    badge: t('head.badge'),
    title1: t('head.title.title1'),
    title2: t('head.title.title2'),
    sub: t('head.text'),
    trust: t('head.trust'),
  };
  const stats = [
    { v: tStats('item1.value'), l: tStats('item1.title') },
    { v: tStats('item2.value'), l: tStats('item2.title') },
    { v: tStats('item3.value'), l: tStats('item3.title') },
    { v: tStats('item4.value'), l: tStats('item4.title') },
  ];
  const { searchedPlate, setSearchedPlate, activeCar } = useLayoutContext();
  const onSearch = (x?: Car | undefined) => {
    setSearchedPlate && setSearchedPlate(x);
  };
  useEffect(() => {
    setSearchedPlate && setSearchedPlate(undefined);
  }, [activeCar]);
  console.log('searchedPlate======', searchedPlate);

  return (
    <section className={styles.section}>
      <div className={styles.glowA} />
      <div className={styles.glowB} />
      <div className={styles.grid_bg} />
      <div className={`container`}>
        <div className={styles.grid}>
          <div>
            <SectionHead
              badge={hero?.badge}
              title={
                <>
                  {hero?.title1}
                  <br />
                  <span className={'titleGrad'}>{hero?.title2}</span>
                </>
              }
              text={hero.sub}
              type="hero"
              headingTag="h1"
            />
            <PlateLookup
              onSearch={onSearch}
              // searchedPlate={searchedPlate}
            />
            <AvatarBadges text={hero?.trust} />
          </div>
          <div className={styles.visual}>{searchedPlate ? <LookupResult /> : <HeroVisual />}</div>
        </div>

        <StatsComponent stats={stats} />
      </div>
    </section>
  );
}
